import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validatePassword][formControlName],[validatePassword][formControl],[validatePassword][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PasswordValidatorDirective),
            multi: true,
        },
    ],
})
export class PasswordValidatorDirective implements Validator
{
    public validate(control: AbstractControl): { [key: string]: any } {
        // All passwords must be at least 8 characters in length.
        if (control.value.length < 8) {
            return {minlength: true};
        }

        // Only enforce alphanumeric / casing restrictions if the password provided is all ASCII characters.
        if (/^[\u0000-\u007f]*$/.test(control.value)) {
            // ASCII characters only.
            // At least a single uppercase letter required.
            if (!(/[A-Z]/.test(control.value))) {
                return {upperCaseLetter: true};
            }

            // At least a single lowercase letter required.
            if (!(/[a-z]/.test(control.value))) {
                return {lowerCaseLetter: true};
            }

            // At least a single numeric required.
            if (!(/[0-9]/.test(control.value))) {
                return {numericLetter: true};
            }
        }

        return null;
    }
}
